// CRA (via craco) inlines process.env.REACT_APP_ * at build time.
export const GATEWAY_URL: string =
  // process.env.REACT_APP_GATEWAY_URL || 'http://localhost:7000/graphql';
  process.env.REACT_APP_GATEWAY_URL || 'https://3lx3jergra.execute-api.ap-south-1.amazonaws.com/prod/graphql';
